import React, { FC, useEffect, useState } from 'react';
import { RootState, useSelector } from 'src/store';
import { TrackingTemplates } from './initValues';

const MultipleChoiceSurveyTracking: FC = () => {
  const currentBranchIndex = useSelector(
    (state: RootState) => state.imageUpload.currentBranchIndex
  );

  return TrackingTemplates[currentBranchIndex];
};

export default MultipleChoiceSurveyTracking;
